import axiosInstance from '../config/axios';

export interface EvidenceSearchRequest {
  selected_text: string;
  transcript: string;
  provider: string;
}

export interface TranscriptMatch {
  matched_text: string;
  context_before: string;
  context_after: string;
  position_info: string;
}

export interface HighlightInfo {
  transcript_matches: TranscriptMatch[];
  search_terms: string[];
}

export interface EvidenceExplanation {
  clinical_significance: string;
  diagnostic_relevance: string;
}

export interface EvidenceSearchResponse {
  evidence_explanation: EvidenceExplanation;
  highlight_info: HighlightInfo;
  user_email: string;
}

class EvidenceService {
  async searchEvidence(
    selectedText: string, 
    transcript: string, 
    provider: string = 'openai'
  ): Promise<EvidenceSearchResponse> {
    try {
      const response = await axiosInstance.post('/api/textprocessing/text-evidence', {
        selected_text: selectedText,
        transcript,
        provider
      });

      return response.data;
    } catch (error) {
      console.error('Evidence search failed:', error);
      throw new Error('Failed to search for evidence. Please try again.');
    }
  }
}

export const evidenceService = new EvidenceService(); 